const video_form_template = `
    <div class='row'>
        <div class='col-lg-12'>
            <amt-form-inline
                name='video.VideoSegmentsForm'
                on-submit='updateCharts(model)'
                extend-model='$root.chartParams.filters'
            >
            </amt-form-inline>
        </div>
    </div>
`;

const inject_video_form = function(state) {
    state['views']['main-filter@amt.ww2'] = {
        template: video_form_template,
    };
    return state;
};

export {
    inject_video_form,
    video_form_template,
};
